export default __webpack_public_path__ + "static/google-cloud-115909df87a05e6949c3b03172c1b416.png";